import React, { useEffect, useState } from "react";
import { Link, useHistory, useParams } from "react-router-dom";
import {
  Button,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Tooltip,
} from "@material-ui/core";
import IconButton from "@material-ui/core/IconButton";
import { makeStyles } from "@material-ui/core/styles";
import CloseIcon from "@material-ui/icons/Close";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import VisibilityIcon from "@material-ui/icons/Visibility";
import axios from "axios";
import formatDate from "../../components/Control/formatDate";
import useConfirm from "../../components/Control/useConfirm";
import { usePermission } from "../../components/usePermission";

const useStyles = makeStyles({
  table: {
    width: "100%",
    marginTop: "1.5rem",
    backgroundColor: "white",
  },
});

const SpecialProcessRevisionList = () => {
  const { specialProcessId } = useParams();
  const history = useHistory();
  const classes = useStyles();
  const permissions = usePermission(6);
  const [specialProcess, setSpecialProcess] = useState(null);
  const [data, setData] = useState([]);
  const [render, setRender] = useState(false);

  const [DialogDelete, confirmDelete] = useConfirm(
    "DELETE REVISION",
    "Are you sure you want to delete this revision?",
  );

  useEffect(() => {
    axios
      .get(`/api/specialProcess/process/${specialProcessId}`)
      .then((res) => setSpecialProcess(res.data))
      .catch((err) => console.log(err));
  }, [specialProcessId]);

  useEffect(() => {
    axios
      .get(`/api/specialProcess/revisions/${specialProcessId}`)
      .then((res) => setData(res.data))
      .catch((err) => console.log(err));
  }, [specialProcessId, render]);

  const removeRevision = async (id) => {
    const ans = await confirmDelete();
    if (!ans) return;
    axios
      .delete(`/api/specialProcess/revision/${id}`)
      .then(() => {
        alert("Revision deleted successfully");
        setRender((prev) => !prev);
      })
      .catch((err) => console.log(err));
  };

  return (
    <>
      <div style={{ paddingBottom: "3rem" }}>
        <div
          className="divflex"
          style={{ fontSize: "24px", justifyContent: "space-between" }}
        >
          LIST OF SPECIAL PROCESS REVISIONS
          <Button
            type="button"
            variant="contained"
            color="primary"
            size="large"
            style={{ backgroundColor: "red", marginRight: "0.5rem" }}
            startIcon={<CloseIcon />}
            onClick={() => history.goBack()}
          >
            Close
          </Button>
        </div>
        <div className="divflex">
          <div>
            <b>Process No. : </b>
            {specialProcess?.process_no}
          </div>
          <div>
            <b>Process Name : </b>
            {specialProcess?.process_name}
          </div>
          <div>
            <b>Category : </b>
            {specialProcess?.category_id?.category_name}
          </div>
        </div>

        <Table
          style={{ marginTop: "3rem" }}
          className={classes.table}
          size="small"
        >
          <TableHead>
            <TableRow style={{ backgroundColor: "white", padding: "6px" }}>
              <TableCell style={{ fontWeight: "bold" }} align="center">
                #
              </TableCell>
              <TableCell style={{ fontWeight: "bold" }} align="center">
                Process Number
              </TableCell>
              <TableCell style={{ fontWeight: "bold" }} align="center">
                Type
              </TableCell>
              <TableCell style={{ fontWeight: "bold" }} align="center">
                Revision number
              </TableCell>
              <TableCell style={{ fontWeight: "bold" }} align="center">
                Revision Date
              </TableCell>
              <TableCell style={{ fontWeight: "bold" }} align="center">
                Action
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {data.map((item, index) => (
              <TableRow key={item._id}>
                <TableCell align="center">{index + 1}</TableCell>
                <TableCell align="center">
                  {item.special_process_id?.process_no}
                </TableCell>
                <TableCell align="center">
                  {item.revision_no > 0 ? "Revised" : "Original"}
                </TableCell>
                <TableCell align="center">{item.revision_no}</TableCell>
                <TableCell align="center">
                  {item.date_review ? formatDate(item.date_review) : "-"}
                </TableCell>
                <TableCell align="center">
                  <Tooltip title="Special Process" arrow>
                    <Link to={`/specialProcess/view/${item._id}`}>
                      <IconButton size="small">
                        <VisibilityIcon
                          style={{ fontSize: "1.4rem", color: "#003566" }}
                        />
                      </IconButton>
                    </Link>
                  </Tooltip>
                  {permissions?.includes("edit") && (
                    <Tooltip title="Edit" arrow>
                      <Link
                        to={`/specialProcess/edit/${specialProcessId}/${item._id}`}
                      >
                        <IconButton
                          size="small"
                          style={{
                            marginLeft: "0.6rem",
                            color: "#161a1d",
                            fontSize: "1.4rem",
                          }}
                        >
                          <EditIcon />
                        </IconButton>
                      </Link>
                    </Tooltip>
                  )}
                  {permissions?.includes("delete") && item.revision_no > 0 && (
                    <Tooltip title="Delete" arrow>
                      <IconButton
                        size="small"
                        style={{ marginLeft: "0.5rem" }}
                        onClick={() => removeRevision(item._id)}
                      >
                        <DeleteIcon
                          style={{ fontSize: "1.4rem", color: "red" }}
                        />
                      </IconButton>
                    </Tooltip>
                  )}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
      <DialogDelete />
    </>
  );
};

export default SpecialProcessRevisionList;
